import React, { useEffect, useState } from "react";
import "./TableTrader.css";

const ITEMS_PER_PAGE = 100;

const TableTrader = ({ data }) => {
  const [tableData, setTableData] = useState([]);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [filteredData, setFilteredData] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  

  const totalPages = Math.ceil(totalItems / ITEMS_PER_PAGE);

  useEffect(() => {
    if (Array.isArray(data)) {
      setFilteredData(data);
      setTotalItems(data.length);
    }
  }, [data]);

  useEffect(() => {
    const startIdx = (currentPage - 1) * ITEMS_PER_PAGE;
    const endIdx = startIdx + ITEMS_PER_PAGE;
    setTableData(filteredData.slice(startIdx, endIdx));
  }, [currentPage, filteredData]);

  const handlePageChange = (newPage) => {
    if (newPage === "next" && currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1);
    } else if (newPage === "previous" && currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  const handleSort = (columnKey) => {
    let direction = "asc";
    if (sortConfig.key === columnKey && sortConfig.direction === "asc") {
      direction = "desc";
    }

    const sortedData = [...filteredData].sort((a, b) => {
      let valueA = a[columnKey];
      let valueB = b[columnKey];

      if (columnKey === "date") {
        valueA = new Date(valueA).getTime();
        valueB = new Date(valueB).getTime();
      } else if (columnKey === "time_block") {
        valueA = Number(valueA);
        valueB = Number(valueB);
      }

      if (valueA < valueB) return direction === "asc" ? -1 : 1;
      if (valueA > valueB) return direction === "asc" ? 1 : -1;
      return 0;
    });

    setSortConfig({ key: columnKey, direction });
    setFilteredData(sortedData);
  };

  const getSortArrow = (columnKey) => {
    if (sortConfig.key === columnKey) {
      return sortConfig.direction === "asc" ? " ▲" : " ▼";
    }
    return " ↕";
  };

  return (
    <div className="trader-wrapper">
      <div className="trader-container">
        <div className="page-container-trader">
          <div className="table-container-Comtrader">
            {error ? (
              <p>Error: {error}</p>
            ) : (
              <table className="table-trader-data-section">
                <thead className="table-thead">
                  <tr>
                    <th
                      className="table-comTrader"
                      onClick={() => handleSort("trader")}
                    >
                      <div className="table-header-content">
                        Trader{" "}
                        <span className="table-span">
                          {getSortArrow("trader")}
                        </span>
                      </div>
                    </th>
                    <th
                      className="table-comTrader"
                      onClick={() => handleSort("product")}
                    >
                      <div className="table-header-content">
                        Product{" "}
                        <span className="table-span">
                          {getSortArrow("product")}
                        </span>
                      </div>
                    </th>
                    <th
                      className="table-comTrader"
                      onClick={() => handleSort("transaction_type")}
                    >
                      <div className="table-header-content">
                        Transaction Type{" "}
                        <span className="table-span">
                          {getSortArrow("transaction_type")}
                        </span>
                      </div>
                    </th>
                    <th
                      className="table-comTrader"
                      onClick={() => handleSort("exchange_type")}
                    >
                      <div className="table-header-content">
                        Exchange Type{" "}
                        <span className="table-span">
                          {getSortArrow("exchange_type")}
                        </span>
                      </div>
                    </th>
                    <th
                      className="table-comTrader"
                      onClick={() => handleSort("date")}
                    >
                      <div className="table-header-content">
                        Date{" "}
                        <span className="table-span">
                          {getSortArrow("date")}
                        </span>
                      </div>
                    </th>
                    {/* <th
                      className="table-comTrader"
                      onClick={() => handleSort("end_date")}
                    >
                      <div className="table-header-content">
                        End Date{" "}
                        <span className="table-span">
                          {getSortArrow("end_date")}
                        </span>
                      </div>
                    </th> */}
                    <th
                      className="table-comTrader"
                      onClick={() => handleSort("time_block")}
                    >
                      <div className="table-header-content">
                        Block{" "}
                        <span className="table-span">
                          {getSortArrow("time_block")}
                        </span>
                      </div>
                    </th>
                    <th
                      className="table-comTrader"
                      onClick={() => handleSort("edited_scheduled_volume_mus")}
                    >
                      <div className="table-header-content">
                        Scheduled Volume (MU){" "}
                        <span className="table-span">
                          {getSortArrow("edited_scheduled_volume_mus")}
                        </span>
                      </div>
                    </th>
                    <th
                      className="table-comTrader"
                      onClick={() => handleSort("name_of_seller")}
                    >
                      <div className="table-header-content">
                        Name of Seller{" "}
                        <span className="table-span">
                          {getSortArrow("name_of_seller")}
                        </span>
                      </div>
                    </th>
                    <th
                      className="table-comTrader"
                      onClick={() => handleSort("category_of_seller")}
                    >
                      <div className="table-header-content">
                        Category of Seller{" "}
                        <span className="table-span">
                          {getSortArrow("category_of_seller")}
                        </span>
                      </div>
                    </th>
                    <th
                      className="table-comTrader"
                      onClick={() => handleSort("state_of_seller")}
                    >
                      <div className="table-header-content">
                        State of Seller{" "}
                        <span className="table-span">
                          {getSortArrow("state_of_seller")}
                        </span>
                      </div>
                    </th>
                    <th
                      className="table-comTrader"
                      onClick={() => handleSort("name_of_buyer")}
                    >
                      <div className="table-header-content">
                        Name of Buyer{" "}
                        <span className="table-span">
                          {getSortArrow("name_of_buyer")}
                        </span>
                      </div>
                    </th>
                    <th
                      className="table-comTrader"
                      onClick={() => handleSort("category_of_buyer")}
                    >
                      <div className="table-header-content">
                        Category of Buyer{" "}
                        <span className="table-span">
                          {getSortArrow("category_of_buyer")}
                        </span>
                      </div>
                    </th>
                    <th
                      className="table-comTrader"
                      onClick={() => handleSort("state_of_buyer")}
                    >
                      <div className="table-header-content">
                        State of Buyer{" "}
                        <span className="table-span">
                          {getSortArrow("state_of_buyer")}
                        </span>
                      </div>
                    </th>
                    <th
                      className="table-comTrader"
                      onClick={() => handleSort("purchase_price_rs_per_kwh")}
                    >
                      <div className="table-header-content">
                        Purchase Price (₹/kW){" "}
                        <span className="table-span">
                          {getSortArrow("purchase_price_rs_per_kwh")}
                        </span>
                      </div>
                    </th>
                    <th
                      className="table-comTrader"
                      onClick={() =>
                        handleSort("sale_price_transaction_price_rs_per_kwh")
                      }
                    >
                      <div className="table-header-content">
                        Sale Price (₹/kW){" "}
                        <span className="table-span">
                          {getSortArrow(
                            "sale_price_transaction_price_rs_per_kwh"
                          )}
                        </span>
                      </div>
                    </th>
                    <th
                      className="table-comTrader"
                      onClick={() =>
                        handleSort("edited_trading_margin_rs_per_kwh")
                      }
                    >
                      <div className="table-header-content">
                        Trading Margin (₹/kW){" "}
                        <span className="table-span">
                          {getSortArrow("edited_trading_margin_rs_per_kwh")}
                        </span>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {tableData.length > 0 ? (
                    tableData.map((ele, index) => (
                      <tr key={index} className="table-content-section">
                        <td className="trader-item">{ele.trader}</td>
                        <td className="trader-item">{ele.product}</td>
                        <td className="trader-item">{ele.transaction_type}</td>
                        <td className="trader-item">{ele.exchange_type}</td>
                        <td className="trader-item">{ele.date}</td>
                        {/* <td className="trader-item">{ele.date}</td> */}
                        <td className="trader-item">{ele.time_block}</td>
                        <td className="trader-item">
                          {ele.edited_scheduled_volume_mus}
                        </td>
                        <td className="trader-item">{ele.name_of_seller}</td>
                        <td className="trader-item">
                          {ele.category_of_seller}
                        </td>
                        <td className="trader-item">{ele.state_of_seller}</td>
                        <td className="trader-item">{ele.name_of_buyer}</td>
                        <td className="trader-item">{ele.category_of_buyer}</td>
                        <td className="trader-item">{ele.state_of_buyer}</td>
                        <td className="trader-item">
                          {ele.edited_purchase_price_rs_per_kwh || ""}
                        </td>
                        <td className="trader-item">
                          {ele.edited_sale_price_transaction_price_rs_per_kwh}
                        </td>
                        <td className="trader-item">
                          {ele.edited_trading_margin_rs_per_kwh}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="18"
                        style={{
                          textAlign: "left",
                          backgroundColor: "#FFFFFF",
                        }}
                      >
                        No Data Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            )}
          </div>

          <div className="trader-button-section">
            <button
              className={` ${
                currentPage === 1 ? "disable_update" : "button-trader-previous"
              }`}
              onClick={() => handlePageChange("previous")}
              disabled={currentPage === 1}
            >
              Prev
            </button>
            <span className="center-page-count"> Page {currentPage} </span>
            <button
              className={` ${
                currentPage === totalPages
                  ? "disable_update"
                  : "button-trader-next"
              }`}
              onClick={() => handlePageChange("next")}
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TableTrader;
